import { render, staticRenderFns } from "./AddNewsModal.vue?vue&type=template&id=f8230da6&"
import script from "./AddNewsModal.vue?vue&type=script&lang=js&"
export * from "./AddNewsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports